import React, { useMemo } from 'react';

import Select, { components } from 'react-select';

import { sendChangedLevelUpProgressEvent } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import { Typography13, Typography14 } from 'uiToolkit/Typography';

const colourStyles = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: 1000,
    width: '175%',
  }),
  menuList: (provided, state) => ({
    ...provided,
    maxHeight: '50vh',
    minHeight: '200px',
  }),
  dropdownIndicator: (styles, data) => ({
    ...styles,
    color: 'transparent',
    padding: '4px',
  }),
  indicatorSeparator: (styles, data) => ({
    ...styles,
    backgroundColor: 'transparent',
  }),
  control: (styles, data) => {
    // const color = data.getValue()[0].color;
    const color = '#ccc';
    return {
      ...styles,
      backgroundColor: 'white',
      width: '16ch',
      minHeight: '40px',
      boxShadow: 'none',
      borderColor: 'transparent',
      ':hover': {
        ...styles[':hover'],
        borderColor: color,
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
      ':focus': {
        ...styles[':focus'],
        borderColor: color,
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
      ':active': {
        ...styles[':active'],
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
    };
  },
  option: (provided) => ({
    ...provided,
    backgroundColor: 'white',
    cursor: 'pointer',
    ':hover': {
      ...provided[':hover'],
      backgroundColor: '#e9f6ff',
    },
  }),
};

export const StatusOption = (props) => {
  const { Option } = components;
  return (
    <Option {...props}>
      <div>
        <Typography14 color={props.data.color} weight={600}>
          {props.data.label}
        </Typography14>
        <Typography13 color={theme.palette.text.blackv1}>{props.data.description}</Typography13>
      </div>
    </Option>
  );
};

export const SingleValueOption = (props) => {
  const { SingleValue } = components;
  return (
    <SingleValue {...props}>
      <div>
        <Typography13 color={props.data.color} weight={600}>
          {props.data.label}
        </Typography13>
      </div>
    </SingleValue>
  );
};

const getColorFromColorEnum = (color) => {
  switch (color) {
    case 'GREY':
      return theme.palette.grey.dark;
    case 'ORANGE':
      return theme.palette.text.orangeRed;
    case 'BLUE':
      return theme.palette.primary.main;
    case 'GREEN':
    case 'DARK_GREEN':
      return theme.palette.green.main;
    case 'PURPLE':
      return theme.palette.purple.darkv1;

    default:
      return theme.palette.grey.dark;
  }
};

const CompetencyProgressSelect = ({
  selectedStatus,
  competencyId,
  subCompetencyId = null,
  handleProgressStatusChange = () => {},
  isDisabled = false,
  levelUpProgressStatuses = [],
  source = '',
}) => {
  const mappedLevelUpProgressStatuses = useMemo(
    () =>
      levelUpProgressStatuses.map((status) => ({
        value: status.progress,
        label: status.displayName,
        color: getColorFromColorEnum(status.colour),
        description: status.description,
      })),
    [levelUpProgressStatuses]
  );

  const handleOnChange = (option) => {
    const matchedStatusObj = mappedLevelUpProgressStatuses.find(({ value }) => value === option.value);
    if (selectedStatus === matchedStatusObj?.value) {
      return;
    }
    sendChangedLevelUpProgressEvent({
      eventProperties: {
        to: option.value,
        from: selectedStatus,
        source,
      },
    });

    handleProgressStatusChange({
      competencyId,
      subCompetencyId,
      progress: matchedStatusObj?.value,
    });
  };

  return (
    <Select
      isDisabled={isDisabled}
      classNamePrefix="react-select"
      label="Single select"
      options={mappedLevelUpProgressStatuses}
      value={mappedLevelUpProgressStatuses.find(({ value }) => value === selectedStatus)}
      onChange={handleOnChange}
      components={{
        Option: StatusOption,
        SingleValue: SingleValueOption,
      }}
      styles={colourStyles}
      isSearchable={false}
      menuShouldScrollIntoView={false}
    />
  );
};

export default CompetencyProgressSelect;
